module.exports = __webpack_public_path__ + "static/media/study 210901.905a42fe.png";